module.exports = __webpack_public_path__ + "static/img/035 2.8aa33d1f.jpg";